module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.main_driver
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('div', {
    staticClass: "card p-1"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48786a0a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/ClientCreditNote.vue
// module id = 2459
// module chunks = 1